module.exports = {
  zh: {
    login: '登录',
    register: '注册',
    about: '关于',
    team: '团队',
    pricing:'收费',
    constructionMsg: '当前服务正在维护中，请稍后再次尝试，谢谢!',
    contactMsg: '欢迎关注我们的公众账号!',
    overview: '项目概况',
    overviewContent:'部署项目可能非常麻烦且令人困惑，尤其是对于那些对部署框架没有经验的人而言。' +
        '另外，开发部署管道需要开发人员方面的时间和精力，以及维护基础架构的必要性。我们的Web应用程序致力于使部署过程自动化，' +
        '并从头到尾抽象出有关部署的基础细节。用户将能够部署多个图像，这些图像将通过自动协调工具进行跨容器通信。' +
        '此外，我们为提供的基础架构提供实时监控，以供用户查看部署进度和最新统计信息。',
    usecase:'商用示例',
    usecaseContent:'开发人员无需担心云部署所需的基础架构。不需要像自动缩放这样的内置手动配置。可以在一处管理多个项目的部署状态。为不同类型的项目提供一个单一的部署模型。负责完整堆栈的部署。 （产品的不同组件，例如后端，前端）',
    goal:'我们的目标',
    goalContent:'开发一个平台即服务，使企业和个人都可以通过更好的资源专注于自己最擅长的事情，而不必担心基础架构的细节问题，从而使企业能够更快，更智能，更好地发展。',
    i18n: '支持多种语言',
    i18nContent: '您可以在我们的平台上选择您的语言，开始并享受您的应用程序部署之旅',
    unlimited: "无限数量的部署和项目更新",
    limitAccess: "对云提供商和服务的有限访问",
    download: "将部署配置资料记录下载到本地",
    registerNow:'现在注册',
    free: '免费',
    vip: '付费会员',
    comingSoon: '快了',
  }
};
